import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-lg md:text-xl">
              <i className="ri-book-read-line"></i>
            </span>
            <span className="font-heading font-bold text-lg md:text-xl text-foreground-900 whitespace-nowrap">
              土豪漫画网
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {[
              { to: '/', label: '首页' },
              { to: '/category/韩漫推荐', label: '韩漫推荐' },
              { to: '/category/日漫大全', label: '日漫大全' },
              { to: '/category/国漫排行榜', label: '国漫排行榜' },
              { to: '/about', label: '关于我们' },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  location.pathname === item.to
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200/70'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-foreground-900 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-3 flex flex-col gap-1">
          {[
            { to: '/', label: '首页' },
            { to: '/category/韩漫推荐', label: '韩漫推荐' },
            { to: '/category/日漫大全', label: '日漫大全' },
            { to: '/category/国漫排行榜', label: '国漫排行榜' },
            { to: '/about', label: '关于我们' },
          ].map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                location.pathname === item.to
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}